import { render } from "./SituationLook.vue?vue&type=template&id=481e340e&scoped=true"
import script from "./SituationLook.vue?vue&type=script&lang=js"
export * from "./SituationLook.vue?vue&type=script&lang=js"

import "./SituationLook.vue?vue&type=style&index=0&id=481e340e&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481e340e"]])

export default __exports__